export default "__VITE_ASSET__dr2tPdOs__"